var BD = BD || {};

//----------------------------------------------------
// BD Affirm
//----------------------------------------------------
BD.Affirm = {};
BD.Affirm.Debounce = function(func, wait, immediate) {
	var timeout;

	return function executedFunction() {
		var context = this;
		var args = arguments;

		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};

		var callNow = immediate && !timeout;

		clearTimeout(timeout);

		timeout = setTimeout(later, wait);

		if (callNow) func.apply(context, args);
	};
};
BD.Affirm.Refresh = BD.Affirm.Debounce(function() {
	if (typeof affirm !== "undefined") {
		affirm.ui.refresh();
		console.log("affirm.ui.refresh()");
	}
}, 250);
